import request from '@/utils/request'

/**
 * 新增用户做题记录
 * @param {Object} data 做题记录数据
 */
export function addRecord(data) {
  return request({
    url: '/user-question-records',
    method: 'post',
    data
  })
}

/**
 * 根据ID删除用户做题记录
 * @param {Number} id 记录ID
 */
export function deleteRecord(id) {
  return request({
    url: `/user-question-records/${id}`,
    method: 'delete'
  })
}

/**
 * 批量删除用户做题记录
 * @param {Array} ids 记录ID列表
 */
export function batchDeleteRecords(ids) {
  return request({
    url: '/user-question-records/batch',
    method: 'delete',
    data: ids
  })
}

/**
 * 更新用户做题记录
 * @param {Object} data 做题记录更新数据
 */
export function updateRecord(data) {
  return request({
    url: '/user-question-records',
    method: 'put',
    data
  })
}

/**
 * 根据ID查询用户做题记录
 * @param {Number} id 记录ID
 */
export function getRecordById(id) {
  return request({
    url: `/user-question-records/${id}`,
    method: 'get'
  })
}

/**
 * 分页查询用户做题记录
 * @param {Object} params 查询参数 {pageNum, pageSize, userId, quesId}
 */
export function getRecordPage(params) {
  return request({
    url: '/user-question-records/page',
    method: 'get',
    params
  })
}

/**
 * 根据用户ID和题库ID删除所有做题记录
 * @param {Number} userId 用户ID
 * @param {Number} repoId 题库ID
 */
export function deleteRecordsByUserAndRepo(userId, repoId) {
  return request({
    url: `/user-question-records/user/${userId}/repo/${repoId}`,
    method: 'delete'
  })
}

export function deleteRecordsByQuesIds(userId, repoId, quesIds) {
  return request({
    url: `/user-question-records/user/${userId}/repo/${repoId}/byQuesIds`,
    method: 'delete',
    params: { quesIds: quesIds.join(',') }
  })
}

/**
 * 根据用户ID查询所有做题记录
 * @param {Number} userId 用户ID
 * @param {Number} repoId 题库ID (可选)
 */
export function getRecordsByUserId(userId, repoId) {
  return request({
    url: `/user-question-records/user/${userId}`,
    method: 'get',
    params: repoId != null && repoId !== '' ? { repoId } : {}
  })
}

/**
 * 根据用户ID查询错误记录
 * @param {Number} userId 用户ID
 * @param {Number} repoId 题库ID (可选)
 */
export function getWrongRecordsByUserId(userId, repoId) {
  return request({
    url: `/user-question-records/user/${userId}/wrong`,
    method: 'get',
    params: repoId ? { repoId } : {}
  })
}

/**
 * 根据题目ID查询所有做题记录
 * @param {Number} quesId 题目ID
 */
export function getRecordsByQuesId(quesId, userId) {
  return request({
    url: `/user-question-records/question/${quesId}`,
    method: 'get',
    params: userId ? { userId } : {}
  })
}

/**
 * 获取用户做题记录总数
 * @param {Number} userId 用户ID (可选)
 */
export function getRecordCount(userId) {
  return request({
    url: '/user-question-records/count',
    method: 'get',
    params: userId ? { userId } : {}
  })
}

/**
 * 根据题库ID统计做题记录数量
 * @param {Number} repoId 题库ID
 * @param {Number} userId 用户ID (可选)
 */
export function countByRepoId(repoId, userId) {
  return request({
    url: `/user-question-records/countByRepoId/${repoId}`,
    method: 'get',
    params: userId ? { userId } : {}
  })
}

/**
 * 根据题库ID统计做题准确率
 * @param {Number} repoId 题库ID
 * @param {Number} userId 用户ID (可选)
 */
export function getAccuracyByRepoId(repoId, userId) {
  return request({
    url: `/user-question-records/accuracyByRepoId/${repoId}`,
    method: 'get',
    params: userId ? { userId } : {}
  })
}

/**
 * 查询所有用户做题记录
 */
export function getAllRecords() {
  return request({
    url: '/user-question-records/all',
    method: 'get'
  })
}

/**
 * 统计今日错题数量
 * @param {Number} userId 用户ID (可选)
 * @param {Number} repoId 题库ID (可选)
 */
export function countTodayWrong(userId, repoId) {
  return request({
    url: '/user-question-records/today/wrong/count',
    method: 'get',
    params: { userId, repoId }
  })
}

/**
 * 查询今日错题列表
 * @param {Number} userId 用户ID (可选)
 * @param {Number} repoId 题库ID (可选)
 */
export function listTodayWrong(userId, repoId) {
  return request({
    url: '/user-question-records/today/wrong/list',
    method: 'get',
    params: { userId, repoId }
  })
}

/**
 * 根据题库ID和天数统计做题准确率
 * @param {Number} repoId 题库ID
 * @param {Number} userId 用户ID (可选)
 * @param {Number} days 天数（0表示今日，3表示近3天等）
 */
export function accuracyByDays(repoId, userId, days) {
  return request({
    url: `/user-question-records/accuracyByDays/${repoId}`,
    method: 'get',
    params: { userId, days }
  })
}

/**
 * 根据题库ID和最近N题统计做题准确率
 * @param {Number} repoId 题库ID
 * @param {Number} userId 用户ID (可选)
 * @param {Number} limit 最近N题
 */
export function accuracyByLastN(repoId, userId, limit) {
  return request({
    url: `/user-question-records/accuracyByLastN/${repoId}`,
    method: 'get',
    params: { userId, limit }
  })
}

/**
 * 统计未复习的错题数量
 * @param {Number} repoId 题库ID
 * @param {Number} userId 用户ID (可选)
 */
export function unreviewedWrongCount(repoId, userId) {
  return request({
    url: `/user-question-records/unreviewedWrongCount/${repoId}`,
    method: 'get',
    params: { userId }
  })
}
